import { useState, useEffect } from 'react';
import { FormGroup } from './FormGroup/FormGroup';
import { useSelector } from 'react-redux';
import { fetchWrapper } from '../_helpers/fetchWrapper';
import { ErrorMessageHandler } from '../_helpers/_methods';
import styled from 'styled-components';

function LocationSelect({
  selectedProvince,
  setSelectedProvince,
  selectedDistrict,
  setSelectedDistrict,
  selectedLocalLevel,
  setSelectedLocalLevel,
  isDashboard,
  isDisabled
}) {
  const local = useSelector((state) => state.local.local);
  const [provinces, setProvinces] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [localLevels, setLocalLevels] = useState([]);

  const handleGetDistrict = (provinceData = []) => {
    let ourProvince = provinceData.find((province) => province.value === selectedProvince.province);

    if (ourProvince) {
      setDistricts(null);
      setLocalLevels(null);
      getDistricts(ourProvince.value, { province: ourProvince });
    }
  };
  useEffect(() => {
    const getProvinces = async () => {
      try {
        const response = await fetchWrapper.get('/province/', true);
        const provinceData = response.results.map((province) => ({
          label: local === 'ne' ? province.title : province.title_en,
          value: province.title
        }));
        setProvinces(provinceData);
        if (selectedProvince) {
          handleGetDistrict(provinceData);
          let ourProvince = provinceData.filter(
            (province) => province.value === selectedProvince.province
          )[0];
          getDistricts(ourProvince.value, { province: ourProvince });
        }
      } catch (error) {
        ErrorMessageHandler(error);
      }
    };
    getProvinces();
  }, []);

  const getDistricts = async (
    province
    // , location
  ) => {
    try {
      const response = await fetchWrapper.get(`/district/?province=${province}&limit=50`);
      const districtsData = response.results.map((district) => ({
        label: local === 'ne' ? district.title : district.title_en,
        value: district.title
      }));
      setDistricts(districtsData);
      // if (
      //   state?.physical_location_details?.district ||
      //   (roster && roster.address && roster.address.length)
      // ) {
      //   let ourDistrict = districtsData.find(
      //     (district) =>
      //       district.value ===
      //       (state.physical_location_details?.district || roster.address[0]?.district)
      //   );
      //   if (ourDistrict) {
      //     setValue(`${id}_physical_location_details.district`, ourDistrict);
      //     getLocalLevel(ourDistrict.value, { ...location, district: ourDistrict });
      //   }
      // }
    } catch (error) {
      ErrorMessageHandler(error);
    }
  };

  const getLocalLevel = async (
    district
    // , location
  ) => {
    try {
      const response = await fetchWrapper.get(`/local_level/?district=${district}&limit=400`);
      const localLevelData = response.results.map((local_level) => ({
        label: local === 'ne' ? local_level.title : local_level.title_en,
        value: local_level.title
      }));
      setLocalLevels(localLevelData);
      // if (state?.physical_location_details?.local_level) {
      //   let ourLocalLevel = localLevelData.filter(
      //     (local_level) => local_level.value === state.physical_location_details.local_level
      //   )[0];
      //   setValue(`${id}_physical_location_details.local_level`, ourLocalLevel);
      //   actions.updateAction({
      //     [`${id}_physical_location_details`]: {
      //       province: location.province,
      //       district: location.district,
      //       local_level: ourLocalLevel
      //     }
      //   });
      // }
    } catch (error) {
      ErrorMessageHandler(error);
    }
  };

  const handleProvinceChange = (element) => {
    setSelectedProvince(element);
    setSelectedDistrict(null);
    setSelectedLocalLevel(null);
    getDistricts(element.value);
  };
  const handleDistrictChange = (element) => {
    setSelectedDistrict(element);
    getLocalLevel(element.value);
  };
  const handleLocalLevelChange = (element) => {
    setSelectedLocalLevel(element);
  };

  return (
    <>
      {isDashboard ? (
        <>
          <StyledSelect>
            <FormGroup
              id={`province`}
              required={true}
              type="select"
              error={{}}
              placeholder={local === 'ne' ? 'प्रदेश चयन गर्नुहोस' : 'Please select Province'}
              onChange={handleProvinceChange}
              options={provinces}
              defaultValue={selectedProvince}
              disabled={isDisabled}
            />
          </StyledSelect>
        </>
      ) : (
        <>
          <StyledSelect className={'col-4'}>
            <FormGroup
              id={`province`}
              required={true}
              type="select"
              error={{}}
              placeholder={local === 'ne' ? 'प्रदेश चयन गर्नुहोस' : 'Please select Province'}
              onChange={handleProvinceChange}
              options={provinces}
              defaultValue={selectedProvince}
            />
          </StyledSelect>
          <StyledSelect className="col-4">
            <FormGroup
              id={`district`}
              type="select"
              required={true}
              error={{}}
              placeholder={local === 'ne' ? 'जिल्ला चयन गर्नुहोस' : 'Please select District'}
              onChange={handleDistrictChange}
              options={districts}
              defaultValue={selectedDistrict}
            />
          </StyledSelect>
          <StyledSelect className="col-4">
            <FormGroup
              id={`local_level`}
              type="select"
              error={{}}
              onChange={handleLocalLevelChange}
              options={localLevels}
              placeholder={local === 'ne' ? 'पालिका चयन गर्नुहोस' : 'Please select Local level'}
              required={true}
              defaultValue={selectedLocalLevel}
            />
          </StyledSelect>
        </>
      )}
    </>
  );
}

export default LocationSelect;

const StyledSelect = styled.div`
  select {
  }
`;
